import { IonContent, IonPage } from '@ionic/react';
import { useIntl } from 'react-intl';
import { ProfileDetails } from 'src/components/profile/ProfileDetails';
import DesktopHeader from 'src/components/reusable-components/desktop-header/DesktopHeader';
import { ProfileMessages } from 'src/intl/ProfileMessages';
import './ProfilePage.css';
import { englishOnlyIntl, useGA4 } from '../../utils/ga4';

export const ProfilePage: React.FC = () => {
  document.title = englishOnlyIntl.formatMessage(ProfileMessages.profile);
  useGA4();

  const { formatMessage } = useIntl();

  return (
    <IonPage className="profile-details-page">
      <DesktopHeader title={formatMessage(ProfileMessages.profile)} />
      <IonContent>
        <ProfileDetails />
      </IonContent>
    </IonPage>
  );
};
